// Utils
import lang from './lang';
import constants from './constants';
import skuHelper from './utils/sku-helper'; // Components

import Sku from './Sku';
import Locale from '../locale';
import SkuActions from './components/SkuActions';
import SkuHeader from './components/SkuHeader';
import SkuHeaderItem from './components/SkuHeaderItem';
import SkuMessages from './components/SkuMessages';
import SkuStepper from './components/SkuStepper';
import SkuRow from './components/SkuRow';
import SkuRowItem from './components/SkuRowItem';
import SkuRowPropItem from './components/SkuRowPropItem';
Locale.add(lang);
Sku.SkuActions = SkuActions;
Sku.SkuHeader = SkuHeader;
Sku.SkuHeaderItem = SkuHeaderItem;
Sku.SkuMessages = SkuMessages;
Sku.SkuStepper = SkuStepper;
Sku.SkuRow = SkuRow;
Sku.SkuRowItem = SkuRowItem;
Sku.SkuRowPropItem = SkuRowPropItem;
Sku.skuHelper = skuHelper;
Sku.skuConstants = constants;
export default Sku;


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/sku/index.js
// module id = 1044
// module chunks = 1